import {
  AvatarContainer,
  ConfirmationPopup,
  InteractiveContainer,
} from "@jugl-web/ui-components/cross-platform";
import { useTranslations } from "@jugl-web/utils";
import { FC, useState } from "react";
import { EntityModel } from "@jugl-web/rest-api";
import { ReactComponent as BuildingIcon } from "./assets/building.svg";

export interface EntityUpdateListItemProps {
  entity: EntityModel;
  updatesCount: number;
  onEntitySwitch: (entity: EntityModel) => void;
}

export const EntityUpdateListItem: FC<EntityUpdateListItemProps> = ({
  entity,
  updatesCount,
  onEntitySwitch,
}) => {
  const [
    isSwitchEntityConfirmationDialogOpen,
    setIsSwitchEntityConfirmationDialogOpen,
  ] = useState(false);

  const { t } = useTranslations();

  return (
    <>
      <InteractiveContainer
        className="flex w-full items-center gap-4 rounded-lg px-4 py-2 transition-colors hover:bg-grey-100"
        onClick={() => setIsSwitchEntityConfirmationDialogOpen(true)}
      >
        <AvatarContainer className="flex h-10 w-10 shrink-0 items-center justify-center border border-solid border-dark-100">
          {entity.logoImg ? (
            <img
              src={entity.logoImg}
              alt={entity.name}
              className="h-full w-full object-cover"
            />
          ) : (
            <BuildingIcon />
          )}
        </AvatarContainer>
        <span className="flex-grow truncate text-base leading-3 font-normal text-dark">
          {entity.name}
        </span>
        <div className="flex h-[19px] w-[40px] shrink-0 items-center justify-center rounded-[50px] bg-secondary">
          <span className="text-[13px] font-medium text-white">
            {updatesCount}
          </span>
        </div>
      </InteractiveContainer>
      <ConfirmationPopup
        variant="web"
        isOpen={isSwitchEntityConfirmationDialogOpen}
        title={t({
          id: "entity-updates-popup-component.switch-workspaces-title",
          defaultMessage: "Switch workspaces",
        })}
        message={t(
          {
            id: "entity-updates-popup-component.switch-workspaces-confirmation",
            defaultMessage:
              "Do you really want to switch workspace to {entityName}?",
          },
          {
            entityName: (
              <span className="font-medium text-primary">{entity.name}</span>
            ),
          }
        )}
        hasCancelButton
        buttons={[
          {
            label: t({
              id: "common.switch",
              defaultMessage: "Switch",
            }),
            color: "primary",
            onClick: () => {
              onEntitySwitch(entity);
              setIsSwitchEntityConfirmationDialogOpen(false);
            },
          },
        ]}
        onRequestClose={() => setIsSwitchEntityConfirmationDialogOpen(false)}
      />
    </>
  );
};
